<template>
  <div class="datatable">
    <table class="datatable-table">
      <tr class="datatable-table-row">
        <th
          v-for="(t, i) in $props.title"
          :key="`datatableTitle-${ i }`"
          class="datatable-table-row-title"
        >
          {{ t.displayName }}
        </th>
      </tr>
      <tr
        v-for="(d, i) in $props.data"
        :key="`datatableRow-${ i }`"
        class="datatable-table-row"
      >
        <td
          v-for="(t, j) in $props.title"
          :key="`datatableData-${ i }-${ j }`"
          class="datatable-table-row-content"
        >
          {{ d[t.name] }}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'Datatable',
  props: {
    /*
     * @property - title
     * Set of titles to display in the table
     */
    title: {
      type: Array,
      default() {
        return [];
      }
    },
    /*
     * @property - data
     * Set of data to display in the table
     */
    data: {
      type: Array,
      default() {
        return [];
      }
    }
  },
};
</script>

<style lang="scss" scoped>
  .datatable {
    @include boxShadow(0.2, true, false);
    overflow: auto;

    &-table {
      border-collapse: collapse;
      width: 100%;

      &-row {
        &:nth-child(even) {
          background-color: $live-blue;
        }

        &-title {
          border: 1px solid $strong-gray;
          min-width: 8rem;
          padding: 1rem;
        }

        &-content {
          border: 1px solid $strong-gray;
          padding: 1rem;
        }
      }
    }
  }
</style>
